import React, { useRef } from 'react'
import Slider from 'react-slick'
import Image from 'next/image'
import { carouselSettings } from '@/utils/carourselConfig'
import Markdown from './Markdown'
import { useDispatch } from 'react-redux'
import { setFilters } from '@/store/slices/speakersSlice'
import { useRouter } from 'next/router'
import { FaPause, FaPlay } from 'react-icons/fa'

const HomeBannerCarousel = ({ data = null, autoPlaySpeed = 5000 }) => {
  if (screen.width <= 480) carouselSettings.speed = 50
  const sliderRef = useRef(null)
  const [isPlaying, setIsPlaying] = React.useState(true)
  return (
    <div className="home-banner-container">
      <Slider
        ref={sliderRef}
        slidesToShow={1}
        slidesToScroll={1}
        initialSlide={0}
        dots={true}
        arrows={false}
        infinite={true}
        speed={2000}
        lazyLoad="ondemand"
        fade={true}
        cssEase="linear"
        autoplay={isPlaying}
        dotsClass="slick-dots-banner flex flex-row justify-center"
        autoplaySpeed={autoPlaySpeed}
        swipeToSlide={true}
        pauseOnHover={false}
        appendDots={(dots) => (
          <div>
            <button
              onClick={() => {
                if (isPlaying) {
                  sliderRef.current.slickPause()
                } else {
                  sliderRef.current.slickPlay()
                }
                setIsPlaying(!isPlaying)
              }}
              className="pt-[10px] hover:bg-gray-300 text-white transition mx-3"
            >
              {isPlaying ? <FaPause /> : <FaPlay />}
            </button>
            <div>{dots}</div>
          </div>
        )}
      >
        {data?.map((item, i) => (
          <SlideItem item={item} key={i} />
        ))}
      </Slider>
    </div>
  )
}

const SlideItem = ({ item }) => {
  const dispatch = useDispatch()
  const router = useRouter()
  const handleRedirect = (contentType, slug) => {
    if (typeof window !== 'undefined') {
      dispatch(
        setFilters({
          categories: null,
          searchQuery: '',
          types: null,
          profileCategory: null,
          relatedSpeakers: null,
          sortOrder: null,
        })
      )
      const url = contentType === 'speakerTopic' ? `/speakers/topics/${slug}` : `/speaker/${slug}`
      router.push(url)
    }
  }
  return (
    <div className="relative aspect-[9/16] md:aspect-[16/9]  overflow-hidden max-h-[calc(100vh-150px)] mx-auto  ">
      <div className="w-full h-full relative mx-auto overflow-hidden block md:hidden">
        <Image
          src={`https:${item.image}?q=100&fit=crop`}
          alt="Example"
          fill
          className="object-cover object-center"
          priority
          sizes="100vw, 50vw, 33vw"
        />
      </div>
      <div className="w-full h-full relative mx-auto overflow-hidden hidden md:block">
        <Image
          src={`https:${item.bannerImage}?q=100`}
          alt="Example"
          fill
          className="object-cover object-center"
          priority
          sizes="100vw, 50vw, 33vw"
        />
      </div>
      <div class="absolute bottom-12 md:bottom-20 lg:bottom-32 left-4 md:left-8 bg-black/60  flex flex-col text-white p-5 w-[302px] gap-[18px] md:w-[350px] lg:w-[600px]">
        <h2 class="text-xs md:text-sm lg:text-lg font-semibold tracking-wide text-transform: uppercase">
          {item.name}
        </h2>
        <div class="mt-2 text-sm md:text-lg">
          <Markdown data={item.bannerText} />
        </div>
        <button
          class="mt-4 px-4 py-2 border border-white hover:bg-white hover:text-black transition w-[190px]"
          onClick={() => handleRedirect(item.contentType, item.slug)}
        >
          {item.contentType === 'speakerTopic' ? 'View' : 'View Speaker'}
        </button>
      </div>
    </div>
  )
}

export default HomeBannerCarousel
